import Model, { ID, MODEL_LEVEL } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'
import Librariable from 'src/models/model/concerns/Librariable'

export default class InventoryItemUnit extends Model {
  static name = 'InventoryItemUnit'

  static versioned = true

  static deletable = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Inventory]

  static define () {
    this.concerns = [Archivable, Librariable]

    this.fields = {
      id: {
        type: ID
      },
      description: {
        type: String
      },
      baseQuantity: {
        type: Number,
        default: 1
      },
      hasAdjustments: {
        type: Boolean,
        output: true,
        default: false
      }
    }

    this.computed = {
      deletable () {
        return !this.isDirty && this.baseQuantity > 1 && !this.hasAdjustments
      },
      archivable () {
        return this.isRemote && !this.isDirty && this.baseQuantity > 1
      },
      baseQuantityIsImmutable () {
        return this.isRemote && (
          (this.baseQuantity === 1 && !_.includes(_.keys(this.describeDirty), 'baseQuantity')) ||
          this.hasAdjustments
        )
      }
    }
  }
}
